import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Check if all required Supabase configuration values are present
if (!supabaseUrl) {
  console.error('Missing Supabase URL. Please check your .env file and ensure REACT_APP_SUPABASE_URL is set.')
  throw new Error('Supabase URL is required.')
}

if (!supabaseAnonKey) {
  console.error('Missing Supabase Anon Key. Please check your .env file and ensure REACT_APP_SUPABASE_ANON_KEY is set.')
  throw new Error('Supabase Anon Key is required.')
}

// Create Supabase client
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

export { supabase } 